import { Component, DestroyRef, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DataClass, Field, Relation } from '../../model/data-model/data-class.model';
import { ApiClientService } from '../../services/api-client.service';

@Component({
    selector: 'app-api-welcome',
    templateUrl: './api-welcome.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ApiWelcomeComponent implements OnInit {
  @Input() tenantCode: string;
  @Input() data: DataClass[] | undefined;
  @Input() dataClass: DataClass | undefined;
  
  isRoot: boolean;
  childDataClasses: DataClass[] | undefined;
  cssClass: string;

  constructor(public api: ApiClientService,
    private route: ActivatedRoute,
    public router: Router,
    private destroyRef: DestroyRef) { }

  ngOnInit(): void {
    this.isRoot = (!this.dataClass);

    if (this.isRoot) {
      this.route.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
        (params: Params) => this.loadRootData(params['tenantCode']));
    } else {
      this.findChildNodes();
    }
  }

  loadRootData(tenantCode: string) {
      this.tenantCode = tenantCode;

      this.api.getClasses(this.tenantCode).subscribe((typeDescriptors) => {
        this.data = typeDescriptors;

        this.dataClass = typeDescriptors.find(dataClass => !dataClass.inherits);
        this.findChildNodes();
      });
  }

  fieldText(field: Field) {
    return `${field.name}${field.required ? '*' : ''} [${field.dataType}]`
  }

  relationText(relation: Relation) {
    if (relation.required && relation.multiple) {
      return `${relation.name} [1..n]`;
    }

    if (relation.required) {
      return `${relation.name} [1]`;
    }

    if (relation.multiple) {
      return `${relation.name} [0..n]`;
    }

    return `${relation.name} [0..1]`;
  }

  findChildNodes() {
    this.cssClass= 'class-list class-list--' + this.dataClass?.kind.toLowerCase();
    // inherits carries the parent's plural REST name; compare against pluralName, not the singular name.
    this.childDataClasses = this.data?.filter(dataClass => dataClass.inherits == this.dataClass?.pluralName);
  }

  onSelectTenant() {
    this.router.navigate(['/tenants']);
  }
}
